export class ZmienKolejnoscPolSpisuModel {
    idProjektu: string;
    nowaKolejnosc: Array<string> = new Array();
}